import {
  SET_SELECTED_COUNTRY,
  SET_SELECTED_BRAND,
  SET_SELECTED_MENU,
} from "./actionTypes"

const initialState = {
  selectedCountry: null,
  selectedBrand: null,
  selectedMenu: null,
}

const MenuFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_COUNTRY:
      return { ...state, selectedCountry: action.payload }
    case SET_SELECTED_BRAND:
      return { ...state, selectedBrand: action.payload }
    case SET_SELECTED_MENU:
      return { ...state, selectedMenu: action.payload }
    default:
      return state
  }
}

export default MenuFilterReducer
